/**
 * Amplitude Feature Flag Experiment 'feature key' constants
 */
export const AmplitudeExperiments = {
    AuctionHouseSearchFiltering: 'sear-701-auction-house-search-filtering',
    BidButtonLabelsMultiVariate: 'bid-button-labels-multi-variate',
    ElasticOnCategoryPages: 'sear-641-use-of-elastic-on-category-pages',
    ElasticVsAlgoliaKeywordSearch: 'la_-_elastic_vs_algolia_keyword_search',
    ExposureVsPageViewedCheck: 'exposure-vs-page-viewed-check',
    ItemPageDiscoverMoreFromThisAuction: 'laac-1126-item-page-discover-more-from-this-auction',
    // new item page layout experiment created 01/12/2026
    LaNewItemPageLayout: 'la-new-item-page-layout-test-2',
    // new bidding console experiment
    NewBiddingConsole: 'laac-916-new-bidding-console',
    NoReservePriceBadge: 'la-display-no-reserve-message',
    PredictiveAverageLotValueInElastic: 'sear-684-predictive-alv-in-elastic',
    SearchResultsAdExperiment: 'ups-4049',
    SimplifiedCategoryPage: 'simplified-category-page',
    VariantJumpingHomePageCheck: 'variant-jumping-home-page-check',
    ZeroResultsSearchPage: 'sear-658-zero-results-search-page-v2',
} as const;

export type AmplitudeExperimentIds = (typeof AmplitudeExperiments)[keyof typeof AmplitudeExperiments];

export const AmplitudeVariants: {
    [key in keyof typeof AmplitudeExperiments]: {
        [variant: string]: string;
        Control: 'control';
        Treatment?: 'treatment';
        TreatmentB?: 'treatmentB';
    };
} = {
    AuctionHouseSearchFiltering: {
        Control: 'control',
        Treatment: 'treatment',
    },
    BidButtonLabelsMultiVariate: {
        Control: 'control',
        LowerLabel: 'treatment-a',
        MiddleLabel: 'treatment-b',
    },
    ElasticOnCategoryPages: {
        Control: 'control',
        Treatment: 'treatment',
    },
    ElasticVsAlgoliaKeywordSearch: {
        Control: 'control',
        Off: 'off',
        Treatment: 'treatment',
    },
    ExposureVsPageViewedCheck: {
        Control: 'control',
        Off: 'off',
        Treatment: 'treatment',
    },

    ItemPageDiscoverMoreFromThisAuction: {
        Control: 'control',
        Treatment: 'treatment',
    },
    LaNewItemPageLayout: {
        Control: 'control',
        Treatment: 'treatment',
    },
    NewBiddingConsole: {
        Control: 'control',
        Treatment: 'treatment',
    },
    NoReservePriceBadge: {
        Control: 'control',
        Treatment: 'treatment',
    },
    PredictiveAverageLotValueInElastic: {
        AddOnlyMLSignals: 'varianta',
        Control: 'control',
        FullRerank: 'variantb',
        PredictedExpectedValueRerank: 'variantc',
    },
    SearchResultsAdExperiment: {
        Control: 'control',
        NewDesign: 'new-design',
    },
    SimplifiedCategoryPage: {
        Control: 'control',
        Treatment: 'treatment',
    },
    VariantJumpingHomePageCheck: {
        Control: 'control',
        Treatment: 'treatment',
    },
    ZeroResultsSearchPage: {
        Control: 'control',
        ZeroResultsWithFuzzyMatch: 'treatmenta',
        ZeroResultsWithNoFuzzyMatch: 'treatmentb',
    },
} as const;

export type AmplitudeExperimentsVariantIds = (typeof AmplitudeVariants)[keyof typeof AmplitudeVariants];
